import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";
import { AddressSuggestionModel } from "@/api/AddressLookup";

export type GetAddressSuggestionsRequest = {
  query: string;
  originLatitude: number;
  originLongitude: number;
  searchRadiusKm: number;
};

export type GetAddressSuggestionsResponse = {
  addressSuggestions: AddressSuggestionModel[];
};

export const getAddressSuggestions = async (request: GetAddressSuggestionsRequest): Promise<GetAddressSuggestionsResponse> => {
  const url = "/addresssuggestions";
  const response = await executeApiRequest(
    () => axios.get<GetAddressSuggestionsResponse>(url, { params: request }),
    false
  );
  return response?.data;
};
